module.exports = __webpack_public_path__ + "static/media/google-play-badge.97d9761d.png";